import React, {Component, ReactNode} from 'react'
import moment, {Moment} from 'moment'
import ReserveAvailabilityOvernight from '../ReserveAvailabilityOvernight'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {FlexGrowContent, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Close} from '@mui/icons-material'
import {Colors} from '../../../styledComponents/Constants'
import {DialogCloseButton, DialogTitle, DialogTitleArea, DisplayItemDividerDialog} from '../components/CommonStyle'
import {
    FacilityName,
    MainArea,
    PanelArea,
    ReservationDetailTD,
    ReservationDurationTD,
    SubTitle,
    TimeSlot,
    TimeSlotTable,
    TimeSlotTR,
} from './RFRSReservationStatusDetailComponent'
import {ReserveAvailabilityOvernightTable} from '../components/ReserveAvailabilityOvernightTable'
import {Nullable} from '../../../app/TypeHelpers'
import {FACILITY_RESERVATION_CLASSIFICATION} from '../../../CodeMaster'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    facilityId: number
    facilityName: string
    reservationId: Nullable<number>
    searchDate: Moment
    onCancel: () => void
    navigate: NavigateFunction
    children?: ReactNode

    reserveAvailabilityOvernight: ReserveAvailabilityOvernight
}

class RFRSReservationStatusDetailForOvernightComponent extends Component<Props> {

    constructor(props: Readonly<Props>) {
        super(props)
    }

    createTimeSlot(): TimeSlot[] {
        const {reservationId, reserveAvailabilityOvernight} = this.props
        const {currentReserves, otherReserves} = reserveAvailabilityOvernight

        const currentTimeSlot: TimeSlot[] = currentReserves
            .filter(current => (current.id !== reservationId))
            .map(current => {
                return {
                    type: 'current',
                    startDateTime: moment(current.checkinDateTime),
                    endDateTime: moment(current.checkoutDateTime),
                    reservationStatus: current.status,
                    ownerName: current.ownerName === null ? 'あなた' : `${current.ownerName}さん`,
                    title: current.title,
                }
            })

        const otherTimeSlot: TimeSlot[] = otherReserves.map(other => {
            return {
                type: 'other',
                startDateTime: moment(other.checkinDateTime),
                endDateTime: moment(other.checkoutDateTime),
                reservationStatus: null,
                ownerName: other.classification === FACILITY_RESERVATION_CLASSIFICATION.ADMIN ? '管理者' : '他の人',
                title: other.title,
            }
        })

        let timeSlotList: TimeSlot[] = []
        timeSlotList = timeSlotList.concat(currentTimeSlot).concat(otherTimeSlot)
        if (timeSlotList.length === 0) {
            return []
        }
        timeSlotList.sort((a, b) => {
            return a.startDateTime.unix() - b.startDateTime.unix()
        })

        return timeSlotList
    }

    renderStatusTable(): ReactNode {
        const timeSlotList: TimeSlot[] = this.createTimeSlot()
        if (timeSlotList.length === 0) {
            return null
        }

        const durationStart = this.props.searchDate.clone().startOf('day')
        const durationEnd = durationStart.clone().add(6, 'day').endOf('day')

        return (<>
            <SubTitle>この施設の予約情報</SubTitle>
            <BlockSpacer height={'10px'}/>
            <TimeSlotTable>
                <tbody>
                {timeSlotList.map((timeSlot, index) =>
                    this.renderTimeSlot(timeSlot, index, durationStart, durationEnd)
                )}
                </tbody>
            </TimeSlotTable>
        </>)
    }

    renderTimeSlot(
        timeSlot: TimeSlot,
        index: number,
        durationStart: Moment,
        durationEnd: Moment
    ): ReactNode {
        const startIsOutOfDuration = timeSlot.startDateTime.isBefore(durationStart)
        const endIsOutOfDuration = timeSlot.endDateTime.isAfter(durationEnd)

        return (
            <TimeSlotTR key={index} type={timeSlot.type}>
                <ReservationDurationTD
                    startDate={timeSlot.startDateTime.format('M/D')}
                    startTime={timeSlot.startDateTime.format('HH:mm')}
                    startIsOutOfDuration={startIsOutOfDuration}
                    endDate={timeSlot.endDateTime.format('M/D')}
                    endTime={timeSlot.endDateTime.format('HH:mm')}
                    endIsOutOfDuration={endIsOutOfDuration}
                />
                <ReservationDetailTD timeSlot={timeSlot}/>
            </TimeSlotTR>
        )
    }

    render(): ReactNode {
        const {facilityName, reservationId, reserveAvailabilityOvernight} = this.props

        return (<>
            <PanelArea>
                <DialogTitleArea>
                    <RowFlexContainer>
                        <DialogTitle>予約状況詳細</DialogTitle>
                        <DialogCloseButton onClick={this.props.onCancel} id={'close'}>
                            <Close fontSize={'large'} style={{color: `${Colors.AccentDark}`}}/>
                        </DialogCloseButton>
                    </RowFlexContainer>
                </DialogTitleArea>
                <DisplayItemDividerDialog/>
                <MainArea>
                    <BlockSpacer height={'14px'}/>
                    <FacilityName>{facilityName}</FacilityName>
                    <BlockSpacer height={'15px'}/>
                    <ReserveAvailabilityOvernightTable
                        statuses={reserveAvailabilityOvernight.reserveAvailableList}
                        myReservations={reserveAvailabilityOvernight.currentReserves}
                        reservationId={reservationId}
                    />
                    <BlockSpacer height={'15px'}/>
                    {this.renderStatusTable()}
                </MainArea>
                <FlexGrowContent/>
            </PanelArea>
        </>)
    }
}

export default RFRSReservationStatusDetailForOvernightComponent
